import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { STORAGE_KEYS } from "@/config/constants";
import { storage } from "@/shared/utils/storage";

import en from "@/i18n/locales/en.json";
import ja from "@/i18n/locales/ja.json";
import id from "@/i18n/locales/id.json";
import vi from "@/i18n/locales/vi.json";
import my from "@/i18n/locales/my.json";
import km from "@/i18n/locales/km.json";
import bn from "@/i18n/locales/bn.json";
import th from "@/i18n/locales/th.json";
import ne from "@/i18n/locales/ne.json";

const SUPPORTED_LANGUAGES = ["en", "ja", "id", "vi", "my", "km", "bn", "th", "ne"];

// Determine initial language from localStorage or browser
const getInitialLanguage = (): string => {
  // First check if user language preference is stored
  const storedLanguage = storage.get(STORAGE_KEYS.LANGUAGE);
  if (storedLanguage && SUPPORTED_LANGUAGES.includes(storedLanguage)) {
    return storedLanguage;
  }

  // Fall back to browser language
  const browserLang = navigator.language.split("-")[0];
  if (SUPPORTED_LANGUAGES.includes(browserLang)) {
    return browserLang;
  }

  return "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ja: { translation: ja },
    id: { translation: id },
    vi: { translation: vi },
    my: { translation: my },
    km: { translation: km },
    bn: { translation: bn },
    th: { translation: th },
    ne: { translation: ne },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// Export utility to change language and persist to storage
export const changeLanguageAndPersist = async (lang: string): Promise<void> => {
  if (SUPPORTED_LANGUAGES.includes(lang)) {
    await i18n.changeLanguage(lang);
    storage.set(STORAGE_KEYS.LANGUAGE, lang);
  }
};

export default i18n;
